(() => {
  const STORAGE_SUBSCRIBED = 'birdega:first-access:subscribed';
  const STORAGE_SEEN = 'birdega:first-access:seen';
  const STORAGE_DISMISSED = 'birdega:first-access:dismissed';
  const COOKIE_SUBSCRIBED = 'birdega_first_access_subscribed';
  const COOKIE_SEEN = 'birdega_first_access_seen';

  const storageGet = (storage, key) => {
    try {
      return storage.getItem(key) === 'true';
    } catch (error) {
      return false;
    }
  };

  const storageSet = (storage, key) => {
    try {
      storage.setItem(key, 'true');
    } catch (error) {
      // Cookie fallbacks below preserve frequency rules when storage is restricted.
    }
  };

  const cookieGet = (name) => document.cookie
    .split('; ')
    .some((cookie) => cookie.startsWith(`${name}=`));

  const cookieSet = (name, persistent = false) => {
    const maxAge = persistent ? '; max-age=31536000' : '';
    document.cookie = `${name}=1; path=/; SameSite=Lax${maxAge}`;
  };

  const markSeen = () => {
    storageSet(sessionStorage, STORAGE_SEEN);
    cookieSet(COOKIE_SEEN);
  };

  const markDismissed = () => {
    storageSet(sessionStorage, STORAGE_DISMISSED);
    markSeen();
  };

  const markSubscribed = () => {
    storageSet(localStorage, STORAGE_SUBSCRIBED);
    markDismissed();
    cookieSet(COOKIE_SUBSCRIBED, true);
  };

  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('dialog');
    const closeButton = root.querySelector('[data-first-access-close]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const liquidSubscribed = root.dataset.subscribed === 'true';
    const postedSuccess = !!root.querySelector('[data-first-access-success]');
    const inlineSuccess = !!document.querySelector('[data-inline-first-access-success]');

    if (inlineSuccess) {
      markSubscribed();
      if (dialog.open) dialog.close();
      return;
    }

    const locallySubscribed =
      storageGet(localStorage, STORAGE_SUBSCRIBED) ||
      cookieGet(COOKIE_SUBSCRIBED);

    const seenThisSession =
      storageGet(sessionStorage, STORAGE_SEEN) ||
      storageGet(sessionStorage, STORAGE_DISMISSED) ||
      cookieGet(COOKIE_SEEN);

    const open = ({ recordSeen = true } = {}) => {
      if (recordSeen) markSeen();
      if (!dialog.open) dialog.showModal();
    };

    const dismiss = () => {
      markDismissed();
      if (dialog.open) dialog.close();
    };

    if (postedSuccess) {
      markSubscribed();
      open({ recordSeen: false });
    } else if (!liquidSubscribed && !locallySubscribed && !seenThisSession) {
      const delay = Math.max(0, Number(root.dataset.delay) || 10000);
      const depth = Math.min(100, Math.max(1, Number(root.dataset.scrollDepth) || 40));
      let opened = false;
      let timerId;

      const cleanupTriggers = () => {
        window.removeEventListener('scroll', onScroll);
        if (timerId) window.clearTimeout(timerId);
      };

      const trigger = () => {
        if (opened) return;
        opened = true;
        cleanupTriggers();
        open();
      };

      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        if ((window.scrollY / scrollable) * 100 >= depth) trigger();
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      timerId = window.setTimeout(trigger, delay);
      onScroll();
    }

    closeButton?.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dismiss();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (event.target?.contains(root)) open({ recordSeen: false });
    });
  };

  const boot = () => document.querySelectorAll('[data-first-access]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
